module.exports = __webpack_public_path__ + "img/6.9616faa7.webp";